/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"

// other
// import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Collapse, Container, Row } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"

import { useHistory, useLocation } from "react-router-dom"
import AlertComponent from "../../../components/AlertComponent"

import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import dayjs from "dayjs"
import { Form } from "react-bootstrap"

import {
  TSyainSyozokuMasterGetReq,
  TSyainSyozokuMasterGetRes,
} from "../../../service/master/syainSyozoku/TSyainSyozokuHenkou"
import SyainSyozokuHenkouListService from "../../../service/master/syainSyozoku/syainSyozokuService"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { useDispatch } from "react-redux"

import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

import ComboBox from "../../../components/ComboBox"
import { AppDispatch } from "../../.."
import { clearAlert, setWarningAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import SyozokuChangeModal from "./SyainSyozokuHenkouModal"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import { FunctionContext } from "../../../components/Context"
import { 区分分類コード, 社員_乗務員 } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"

/**
 * 社員所属変更一覧
 */
const MasterSyainSyozokuHenkouList = () => {
  const history = useHistory()
  const location = useLocation()
  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinSyozokuMaster_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TSyainSyozokuMasterGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyainSyozokuMasterGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) //Alertクリア

    let currentSearchCondition: TSyainSyozokuMasterGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    // modal用
    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyainSyozokuHenkouListService().getSyozokuList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索状態切り替え
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyainSyozokuMasterGetReq = queryString.parse(location.search)
    set社員氏名(query.社員氏名)
    set部所コード(query.部所コード ?? "")
    set社員コード(query.社員コード)
    set社員区分コード(query.社員区分コード ?? "")
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyainSyozokuMasterGetReq => {
    return {
      部所コード: 部所コード ?? undefined,
      社員コード: 社員コード ?? undefined,
      社員氏名: 社員氏名 ?? undefined,
      社員区分コード: 社員区分コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyainSyozokuMasterGetReq
  ) => {
    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
      社員コード: searchCondition?.社員コード,
      社員氏名: searchCondition?.社員氏名,
      社員区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.社員区分コード &&
          i.分類コード === 社員_乗務員.社員区分
      )?.名称1,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    set社員氏名("")
    set部所コード("")
    set社員コード("")
    set社員区分コード("")
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return
    var columnHeaders = f.columnHeaders

    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      if (c.binding?.includes("現在_")) {
        columnHeaders.setCellData(0, index, "現在の所属部所")
      } else if (c.binding?.includes("異動先_")) {
        columnHeaders.setCellData(0, index, "異動先の部所")
      } else {
        const setHeaderText = c.header ?? ""
        columnHeaders.setCellData(0, index, setHeaderText)
      }

      c.allowMerging = true
    })

    // フォーマットのループ制御
    ref明細フォーマットフラグ.current = true
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [dataInitialized, setDataInitialized] = useState<boolean>(false)

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //modal
  const [isSyozokuModalShow, setIsSyozokuModalShow] = useState<boolean>(false)
  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TSyainSyozokuMasterGetReq>({} as TSyainSyozokuMasterGetReq)

  //#endregion

  //#region [state]
  const [社員区分コード, set社員区分コード] = useState<string | null>(null)
  // ComboBoxState
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  // 設定
  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [社員氏名, set社員氏名] = useState<string | null>()
  const [社員コード, set社員コード] = useState<string | null>()

  // modal受け渡し
  const [社員ID, set社員ID] = useState<number>()
  const [所属部所ID, set所属部所ID] = useState<number>()

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // 社員区分
  const [社員区分ComboBox, set社員区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [社員区分IsLoadEnded, set社員区分IsLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    // TODO: APIから取得に修正必須
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && dataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, dataInitialized])

  useEffect(() => {
    document.title = `社員所属変更一覧`
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set区分ItemSource(区分マスタRes.data)
      set部所ItemSource(部所ListRes.data)
      setDataInitialized(true)
    })
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">社員所属変更一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <ul className="list-cmn d-flex">
                          <li className="list-cmn">
                            <div className="w-15rem">
                              <ComboBox.Busyo
                                autoFocus
                                placeholder="部所"
                                isAllSelect={true}
                                itemsSource={部所ItemSource}
                                isLoadEnded={部所IsLoadEnded}
                                setIsLoadEnded={set部所IsLoadEnded}
                                setSelectedValue={set部所コード}
                                selectedValue={部所コード}
                                setSelectedItem={set部所}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                          </li>
                          <li className="list-cmn list-padding">
                            <div className="w-5rem">
                              <TextInput
                                id="社員コード"
                                name="社員コード"
                                value={社員コード ?? ""}
                                setValue={set社員コード}
                                placeholder="社員CD"
                              />
                            </div>
                          </li>
                          <li className="list-cmn list-padding">
                            <div className="w-15rem">
                              <TextInput
                                id="社員氏名"
                                name="社員氏名"
                                value={社員氏名 ?? ""}
                                setValue={set社員氏名}
                                placeholder="社員氏名"
                              />
                            </div>
                          </li>
                          <li className="list-cmn">
                            <div className="w-15rem">
                              <ComboBox.Kubun
                                placeholder="社員区分"
                                分類コード={区分分類コード.社員_乗務員.社員区分}
                                isAllSelect={true}
                                itemsSource={区分ItemSource}
                                selectedValue={社員区分コード}
                                setSelectedValue={set社員区分コード}
                                isLoadEnded={社員区分IsLoadEnded}
                                setIsLoadEnded={set社員区分IsLoadEnded}
                                ComboBox={社員区分ComboBox}
                                setComboBox={
                                  set社員区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                          </li>
                        </ul>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <FunctionContext.Provider
        value={() => {
          search(preSearchCondition)
        }}>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  gridProperties={{
                    allowSorting: wjGrid.AllowSorting.None,
                    allowDragging: wjGrid.AllowDragging.None,
                  }}>
                  <wjrGrid.FlexGridColumn
                    header=" "
                    align="center"
                    width={90}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyainSyozokuMasterGetRes>
                      ) => {
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              set所属部所ID(context.item.異動先_所属部所ID)
                              set社員ID(context.item.社員ID)
                              setIsSyozokuModalShow(true)
                              dispatch(clearAlert()) //Alertクリア
                            }}>
                            所属変更
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員コード"
                    width={90}
                    header="社員CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員氏名"
                    width={150}
                    header="氏名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_所属開始日"
                    width={128}
                    header="所属開始日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyainSyozokuMasterGetRes>
                      ) => {
                        let dt = ""
                        if (context.item.現在_所属開始日)
                          dt = dayjs(context.item.現在_所属開始日).format(
                            "YYYY/MM/DD"
                          )
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_部所名"
                    width={200}
                    header="部所名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_社員区分名称"
                    width={100}
                    header="社員区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="現在_備考"
                    width={200}
                    header="備考"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_異動日"
                    width={120}
                    header="異動日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TSyainSyozokuMasterGetRes>
                      ) => {
                        let dt = ""
                        if (context.item.異動先_所属開始日)
                          dt = dayjs(context.item.異動先_所属開始日).format(
                            "YYYY/MM/DD"
                          )
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_部所名"
                    width={200}
                    header="部所名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_社員区分名称"
                    width={100}
                    header="社員区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="異動先_備考"
                    width={200}
                    header="備考"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <SyozokuChangeModal
          isShow={isSyozokuModalShow}
          setIsShow={(v) => {
            setIsSyozokuModalShow(v)
          }}
          社員ID={社員ID!}
          登録更新={所属部所ID ? "更新" : "登録"}></SyozokuChangeModal>
      </FunctionContext.Provider>
    </Container>
  )
}

export default MasterSyainSyozokuHenkouList
